/* eslint-disable complexity */
import { KuendigungsGrund } from '@/domain/vertraege/shared/types/kuendigungsGrund';
import { Vertraege_KuendigungsGrund } from '@/gql/graphql';

export function mapKuendigungsGrund(grund: KuendigungsGrund) {
  switch (grund) {
    case KuendigungsGrund.FEHLENDER_SUPPORT:
      return Vertraege_KuendigungsGrund.FehlenderSupport;
    case KuendigungsGrund.FEHLENDE_FUNKTION:
      return Vertraege_KuendigungsGrund.FehlendeFunktion;
    case KuendigungsGrund.GESCHAEFTSAUFGABE:
      return Vertraege_KuendigungsGrund.Geschaeftsaufgabe;
    case KuendigungsGrund.INHABERWECHSEL:
      return Vertraege_KuendigungsGrund.Inhaberwechsel;
    case KuendigungsGrund.INSOLVENZ:
      return Vertraege_KuendigungsGrund.Insolvenz;
    case KuendigungsGrund.KOSTEN:
      return Vertraege_KuendigungsGrund.Kosten;
    case KuendigungsGrund.MANGELHAFTES_ONBOARDING:
      return Vertraege_KuendigungsGrund.MangelhaftesOnboarding;
    case KuendigungsGrund.MARKTBEGLEITER:
      return Vertraege_KuendigungsGrund.Marktbegleiter;
    case KuendigungsGrund.ZEIT:
      return Vertraege_KuendigungsGrund.Zeit;
  }
}
